import { selectFromRouteTemplatesDto } from '../../models';

export default selectFromRouteTemplatesDto()
  .active
  .routeLimit
  .toString();
